const INITIAL_STATE = { isManutencao: false };
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'SETMANUTENCAO':
      state = { ...INITIAL_STATE, isManutencao: action.isManutencao };
      return state;
    case 'SETINATIVO':
      state = { ...INITIAL_STATE, isInativo: action.isInativo };
      return state;
    default:
      return state;
  }
};